import { render, staticRenderFns } from "./ReportsDetail.vue?vue&type=template&id=28f45a89&scoped=true&"
import script from "./ReportsDetail.vue?vue&type=script&lang=js&"
export * from "./ReportsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReportsDetail.vue?vue&type=style&index=0&id=28f45a89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f45a89",
  null
  
)

export default component.exports